import { AdviseCurrentSuppliers, NewCurrentSupplier, SupplierDirectoryRow } from '../../../../types/advise';
import { CURRENT_SUPPLIER_NAME_LIMIT } from './currentSupplierLimits';

const comparable = (name: string) => name.trim().replace(/\s+/g, ' ').toLowerCase();

export const catalogMatch = (name: string, directory: SupplierDirectoryRow[]): SupplierDirectoryRow | null => {
  const matches = directory.filter((row) => comparable(row.supplier_name) === comparable(name));
  return matches.length === 1 ? matches[0] : null;
};

// A supplier's card offers Edit on its hand-entered lines only once its entry says so, and upstack_api sets none itself.
export const newCurrentSupplierEntry = (
  name: string,
  row: SupplierDirectoryRow | null,
  manualEntry = false
): NewCurrentSupplier => {
  // A catalog name can run past what the field lets a user type, and the API refuses one over the limit.
  const entry = {
    name: (row?.supplier_name ?? name).trim().slice(0, CURRENT_SUPPLIER_NAME_LIMIT).trim(),
    ...(manualEntry && { spend_entry: 'line_items' as const })
  };
  if (row?.id) return { ...entry, supplier_id: row.id };
  if (row?.sf_supplier_id) return { ...entry, sf_supplier_id: row.sf_supplier_id };
  return entry;
};

// A create answers with the whole engagement, oldest supplier first, so the new one is the last of its name it hadn't
// before; upstack_api stores the name as sent, its ends stripped.
export const addedSupplierId = (
  before: AdviseCurrentSuppliers,
  after: AdviseCurrentSuppliers,
  name: string
): string | null => {
  const known = new Set((before.suppliers ?? []).map((supplier) => supplier.id));
  const added = (after.suppliers ?? []).filter((supplier) => !known.has(supplier.id) && supplier.name === name);
  return added.pop()?.id ?? null;
};
